// Investiture
import React from 'react';
import Hindiccaclass12025 from '../views/Hindiccaclass12025';

const InvestiturePage = () => {
  return <Hindiccaclass12025 />;
};

export default InvestiturePage;
